import Types from "./Types";

export const getAllStudentsRequest = (body) => ({
  type: Types.GET_SUPERADMIN_STUDENTS_REQUEST,
  payload: body,
});

export const getAllStudentsSuccess = (data) => ({
  type: Types.GET_SUPERADMIN_STUDENTS_SUCCESS,
  payload: data,
});

export const getAllStudentsFail = () => ({
  type: Types.GET_SUPERADMIN_STUDENTS_FAIL,
});

export const getAllActiveStudentsRequest = (body) => ({
  type: Types.GET_SUPERADMIN_ACTIVE_STUDENTS_REQUEST,
  payload: body,
});

export const getAllActiveStudentsSuccess = (data) => ({
  type: Types.GET_SUPERADMIN_ACTIVE_STUDENTS_SUCCESS,
  payload: data,
});

export const getAllActiveStudentsFail = () => ({
  type: Types.GET_SUPERADMIN_ACTIVE_STUDENTS_FAIL,
});
export const approveStudentRequest = (formData, action) => ({
  type: Types.APPROVE_SUPERADMIN_STUDENT_REQUEST,
  payload: formData,
  action: action,
});

export const approveStudentSuccess = (data) => ({
  type: Types.APPROVE_SUPERADMIN_STUDENT_SUCCESS,
  payload: data,
});

export const approveStudentFail = () => ({
  type: Types.APPROVE_SUPERADMIN_STUDENT_FAIL,
});
export const rejectStudentRequest = (data) => ({
  type: Types.REJECT_SUPERADMIN_STUDENT_REQUEST,
  payload: data,
});

export const rejectStudentSuccess = (data) => ({
  type: Types.REJECT_SUPERADMIN_STUDENT_SUCCESS,
  payload: data,
});

export const rejectStudentFail = () => ({
  type: Types.REJECT_SUPERADMIN_STUDENT_FAIL,
});

export const studentLoading = (isLoading) => ({
  type: Types.SUPERADMIN_STUDENTS_LOADING,
  payload: isLoading,
});

export const addBulkStudentRequest = (formData) => ({
  type: Types.SUPERADMIN_ADD_BULK_STUDENT_REQUEST,
  payload: formData,
});

export const addBulkStudentSuccess = (id) => ({
  type: Types.SUPERADMIN_ADD_BULK_STUDENT_SUCCESS,
  payload: id,
});

export const addBulkStudentFail = () => ({
  type: Types.SUPERADMIN_ADD_BULK_STUDENT_FAIL,
});

export const createStudentRequest = (formData, action) => ({
  type: Types.CREATE_SUPERADMIN_STUDENT_REQUEST,
  payload: formData,
  action: action,
});

export const createStudentSuccess = ({ data }) => ({
  type: Types.CREATE_SUPERADMIN_STUDENT_SUCCESS,
  payload: {
    data,
  },
});

export const createStudentFail = () => ({
  type: Types.CREATE_SUPERADMIN_STUDENT_FAIL,
});

export const editStudentRequest = (formData, action) => ({
  type: Types.EDIT_SUPERADMIN_STUDENT_REQUEST,
  payload: formData,
  action: action,
});

export const editStudentSuccess = ({ data }) => ({
  type: Types.EDIT_SUPERADMIN_STUDENT_SUCCESS,
  payload: {
    data,
  },
});

export const editStudentFail = () => ({
  type: Types.EDIT_SUPERADMIN_STUDENT_FAIL,
});

export const deleteStudentRequest = (id) => ({
  type: Types.DELETE_SUPERADMIN_STUDENT_REQUEST,
  payload: id,
});

export const deleteStudentSuccess = (id) => ({
  type: Types.DELETE_SUPERADMIN_STUDENT_SUCCESS,
  payload: id,
});

export const deleteStudentFail = () => ({
  type: Types.DELETE_SUPERADMIN_STUDENT_FAIL,
});